export const DEFAULT_HERO_HEIGHT = 280;
